import { george, i18n, observer, pr, React, RouteComponentProps } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { ui } from "../util/uiHelpers";
import { GIGRoutes } from "./GIGRoutes";
import { GIGStore } from "./GIGStore";

type IProps = RouteComponentProps<{}> & {
    store: GIGStore
};

@observer
export class GIGPrecontract extends React.Component<IProps, {}> {
    onActivate = async () => {
        try {
            await this.props.store.activate();
            pushRoute(GIGRoutes.SIGNING);
        } catch (error) {
            pushRoute("/error");
        }
    }

    render() {
        return (
            <>
                <george.BackgroundWithNavBar>
                    <george.PageWithActionButton>
                        <george.Card>
                            <george.CardSectionTitle title={ui.__("gig.precontract.header")} />
                            <george.CardSectionContent>
                                <pr.P_14_CONTENT>
                                    <i18n.FormattedHTMLMessage id="gig.precontract.text" />
                                </pr.P_14_CONTENT>
                            </george.CardSectionContent>
                        </george.Card>
                        <george.ActionButton
                            messageId="common.agree.short"
                            onClick={this.onActivate}
                            isLoading={this.props.store.isLoading()}
                            disableButton={!this.props.store.contactsStore.selectedEmailAddressId}
                            primary
                        />
                    </george.PageWithActionButton>
                </george.BackgroundWithNavBar>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/gig/GIGPrecontract.tsx